<template>
  <div class="page" :class="{transO:isTrans}">
    <div class="head-warp">
      <div class="title">诚信合作，创新共享</div>
      <div class="description">赢科天地专注于中国教育行业信息化建设十余年，不断创新技术应用模式，成为引领高等院校信息化建设的高科技企业。</div>
    </div>
    <div class="top">
      <h2 class="title">招聘信息</h2>
      <div class="bg">
        <div class="description">这里凝聚起每个人的创造力，大家秉承着共同的价值观，一起为成就伟大事业而努力。在这里，你不只是加入我们，更会为我们带来精彩新思维。</div>
      </div>
    </div>
    <div>
      <img width="100%" src="../assets/zpqs-2.jpg" alt="">
    </div>
    <div class="container">
      <div class="dec">
        <h2 class="title">学习的机会，培育新的机遇</h2>
        <div class="description">“变道”人生路<br>
人生有许多种可能，只要英勇一次，往往能得到的东西能比想象中多得多。如今，赢科天地为你提供一种人生：诚邀志同道合的朋友与我们一起共建中国领先的高等教育信息化产品和服务供应商，助力高等教育信息化发展，为教育现代化建设贡献一份力量。
         </div>
      </div>
      <div class="search">
        <div class="address">
          <Select v-model="city" filterable clearable placeholder="请选择城市">
            <Option v-for="item in cityList" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </div>
        <div class="address">
          <Select v-model="job" filterable clearable placeholder="请选择岗位">
            <Option v-for="item in zwList" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </div>
        <Button class="search-btn" style="" type="text" icon="ios-search" @click="searchClick"></Button>
      </div>
      <div class="job-list">
        <div class="job-item" v-for="(item,index) in tempList" :key="index">
          <div class="job-name">
            <div class="title">{{item.title}}</div>
            <div class="arrow" @click="goToNewPage('/jobs', item)">
              查看详情
              <Icon type="ios-arrow-forward" />
            </div>
          </div>
          <div class="job-content">
            <div>岗位类别：{{item.remark01}}</div>
            <div>招聘人数：{{item.remark02}}</div>
            <div>工作地点：{{item.remark03}}</div>
            <div>发布时间：{{item.times}}</div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data() {
    return {
      cityList: [
        { label: '北京', value: '北京' },
        { label: '哈尔滨', value: '哈尔滨' },
        { label: '成都', value: '成都' },
        { label: '青岛', value: '青岛' },
      ],
      tempList: [
        { title: 'Java开发工程师', remark01: 'Java开发工程师', remark02: '2人', remark03: '北京、哈尔滨', times: '2026-06-01', id: 'job001' },
        { title: '产品经理', remark01: '产品经理', remark02: '1人', remark03: '北京', times: '2026-06-15', id: 'job003' },
        { title: '实施工程师', remark01: '实施工程师', remark02: '3人', remark03: '成都、青岛', times: '2026-05-28', id: 'job004' },
        { title: '测试工程师', remark01: '测试工程师', remark02: '2人', remark03: '北京', times: '2026-05-20', id: 'job005' },
        { title: 'UI设计师', remark01: 'UI设计师', remark02: '1人', remark03: '北京', times: '2026-05-12', id: 'job006' },
      ],
      zwList: [
        { label: 'Java开发工程师', value: 'Java开发工程师' },
        { label: '前端开发工程师', value: '前端开发工程师' },
        { label: '产品经理', value: '产品经理' },
        { label: '实施工程师', value: '实施工程师' },
        { label: '测试工程师', value: '测试工程师' },
        { label: 'UI设计师', value: 'UI设计师' },
      ],
      jobList: [
        { title: 'Java开发工程师', remark01: 'Java开发工程师', remark02: '2人', remark03: '北京、哈尔滨', times: '2026-06-01', id: 'job001' },
        { title: '产品经理', remark01: '产品经理', remark02: '1人', remark03: '北京', times: '2026-06-15', id: 'job003' },
        { title: '实施工程师', remark01: '实施工程师', remark02: '3人', remark03: '成都、青岛', times: '2026-05-28', id: 'job004' },
        { title: '测试工程师', remark01: '测试工程师', remark02: '2人', remark03: '北京', times: '2026-05-20', id: 'job005' },
        { title: 'UI设计师', remark01: 'UI设计师', remark02: '1人', remark03: '北京', times: '2026-05-12', id: 'job006' },
      ],
      city: '',
      job: '',
      isTrans: false,
      timer: '',
    }
  },
  methods: {
    //判断字符是否为空的方法
    isEmpty(obj) {
      if (typeof obj == 'undefined' || obj == null || obj == '') {
        return true
      } else {
        return false
      }
    },
    searchClick() {
      var array = []

      if (!this.isEmpty(this.city) || !this.isEmpty(this.job)) {
        for (const item of this.jobList) {
          if (!this.isEmpty(this.city) && !this.isEmpty(this.job)) {
            // if (item.remark03 === this.city && item.remark01 === this.job) {
            //   array.push(item)
            // }
			if (item.remark03.search(this.city) != -1 && item.remark01.search(this.job) != -1) {
			  array.push(item)
			}
          } else if (!this.isEmpty(this.city)) {
            // if (item.remark03 === this.city) {
            //   array.push(item)
            // }
			if (item.remark03.search(this.city) != -1) {
			  array.push(item)
			}
          } else if (!this.isEmpty(this.job)) {
            // if (item.remark01 === this.job) {
            //   array.push(item)
            // }
			if (item.remark01.search(this.job) != -1) {
			  array.push(item)
			}
          }
        }
      } else {
        array = this.jobList
      }
      this.tempList = array
    },
    goToNewPage(path, item) {
      // this.$router.push({
      //   path: path,
      //   query: {
      //     id: item.id,
      //   },
      // })
	  
	  let routeUrl = this.$router.resolve({
	       path: path,
	       query: {id:item.id}
	     });
	  window.open(routeUrl.href, '_blank');
    },
  },
  mounted() {
    this.timer = setInterval(() => {
      this.isTrans = true
      clearInterval(this.timer)
    }, 100)

    let url =
      this.HOST +
      'wzPage/getJson?id=C83BA372722416C2E05509994F3826F5&moduleOrder=ordernum&contentOrder=ordernum&websiteid=4'
    url = this.$getJsonUrl(url)
    this.$axios.get(url).then((res) => {
      this.jobList = res.data.content[0].children[0].list
      this.tempList = res.data.content[0].children[0].list
      var array = []
      for (const item of this.jobList) {
		  // array.push(item.remark03)
		var citys = item.remark03.split('、')
        array.push.apply(array, citys)
      }

      const set = new Set(array)
      var cityList = [...set]
      var list = []
      for (let i = 0; i < cityList.length; i++) {
        list.push({ label: cityList[i], value: cityList[i] })
      }
      this.cityList = list

      var array1 = []
      for (const item of this.jobList) {
        array1.push(item.remark01)
      }

      const set1 = new Set(array1)
      var zwList = [...set1]
      var list1 = []
      for (let i = 0; i < zwList.length; i++) {
        list1.push({ label: zwList[i], value: zwList[i] })
      }
      this.zwList = list1
    })
  },
}
</script>

<style lang="less" scoped>
.page {
  margin-bottom: 200px;
  opacity: 0;
  transition: opacity 2s ease-in-out;
  .head-warp {
    padding: 20px 80px;
    text-align: left;
    background-image: url('../assets/zpqs.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    .title {
      font-size: 22px;
      font-weight: 600;
      line-height: 40px;
    }
    .description {
      width: 550px;
      font-size: 16px;
    }
  }
  .top {
    .title {
      text-align: center;
      line-height: 60px;
      font-size: 16px;
      font-weight: 700;
    }
    .bg {
      padding: 20px 0;
      background-image: url('../assets/zxyfw.jpg');
      background-repeat: no-repeat;
      background-size: cover;
      .description {
        width: 350px;
        margin: 0 auto;
        line-height: 20px;
        font-size: 18px;
        font-weight: 700;
        color: #fff;
      }
    }
  }
  .container {
    width: 1000px;
    margin: 0 auto;
    .dec {
      text-align: left;
      .title {
        font-size: 18px;
        font-weight: 700;
        line-height: 60px;
      }
      .description {
        font-size: 16px;
      }
    }
    .search {
      .address {
        display: inline-block;
        width: 200px;
        margin-right: 20px;
      }
      .search-btn {
        width: 60px;
        margin: 30px 0;
        color: #fff;
        background-image: url('../assets/zxyfw.jpg');
        background-repeat: no-repeat;
        background-size: cover;
      }
    }
    .job-list {
      // height: 500px;
      // overflow: auto;
      .job-item {
        padding: 20px;
        margin-bottom: 20px;
        border: 1px solid #ddd;
        .job-name {
          display: flex;
          justify-content: space-between;
          padding-bottom: 12px;
          border-bottom: 1px solid #ddd;
          .title {
            font-weight: 600;
          }
          .arrow {
            cursor: pointer;
            color: #1c7791;
          }
        }
        .job-content {
          display: flex;
          margin-top: 12px;
          & > div {
            flex: 1;
          }
        }
        &:hover {
          background-image: url('../assets/zxyfw.jpg');
          background-repeat: no-repeat;
          background-size: cover;
          color: #fff;
          .arrow {
            color: #fff;
          }
        }
      }
    }
  }
}
.transO {
  opacity: 1 !important;
}
</style>

